import { MultiOption, MultiOptionValue } from './MultiSelect.component';

function getSearchStringFromOption<T = string>(option: MultiOption<T>): string {
  if ('searchValue' in option && option.searchValue) return option.searchValue;
  if (typeof option.label === 'string') return option.label;
  return '';
}

function checkIsSelected<T = MultiOptionValue>(
  options: Array<MultiOption<T>>,
  value: T,
) {
  if (typeof value === 'string')
    return options.findIndex((opt) => opt.value === value) !== -1;
}

function isObjectArray<T>(values: Array<T>) {
  return values.every(
    (obj) => typeof obj === 'object' && 'label' in obj && 'value' in obj,
  );
}

function arrayFromValues<T = MultiOptionValue>(
  values: Array<T>,
  options: Array<MultiOption<T>>,
) {
  return values
    .map((value) => {
      if (typeof value === 'string')
        return options.find((opt) => opt.value === value);
      else if (typeof value === 'object' && 'label' in value) return value;
      return '';
    })
    .filter((v) => v !== '');
}

export {
  getSearchStringFromOption,
  checkIsSelected,
  isObjectArray,
  arrayFromValues,
};
